import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import BoatService from '../../services/BoatService';
import ChangePassword from '../auth/ChangePassword';
import './Dashboard.css';

const Dashboard = ({ onBoatUpdate }) => {
  const { user, token } = useAuth();
  const [assignedBoats, setAssignedBoats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showChangePassword, setShowChangePassword] = useState(false);

  useEffect(() => {
    if (user) {
      fetchAssignedBoats();
    }
  }, [user, token]);

  const fetchAssignedBoats = async () => {
    if (!user || !user.assignedBoats || user.assignedBoats.length === 0) {
      setAssignedBoats([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const data = await BoatService.getBoatsRegistry(token);
      // Filter boats that are assigned to the user
      const userBoats = data.filter(boat => 
        user.assignedBoats.includes(boat.boatId)
      );
      setAssignedBoats(userBoats);
      setError(null);
      
      // Notify parent to refresh map data if provided
      if (onBoatUpdate) {
        onBoatUpdate();
      }
    } catch (err) {
      setError('Failed to load assigned boats: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return <div className="dashboard-loading">Loading user data...</div>;
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h2>उपयोगकर्ता डैशबोर्ड | User Dashboard</h2>
      </div>

      {error && <div className="dashboard-error">{error}</div>}

      <div className="dashboard-content">
        <div className="dashboard-card profile-card">
          <h3>प्रोफ़ाइल | Profile</h3>
          <div className="profile-details">
            <div className="profile-item">
              <span className="profile-label">नाम | Name:</span>
              <span className="profile-value">{user.name}</span>
            </div>
            <div className="profile-item">
              <span className="profile-label">यूजरनेम | Username:</span>
              <span className="profile-value">{user.username}</span>
            </div>
            <div className="profile-item">
              <span className="profile-label">भूमिका | Role:</span>
              <span className="profile-value role-badge">
                {user.role === 'admin' ? 'प्रशासक | Admin' : 'ऑपरेटर | Operator'}
              </span>
            </div>
            <div className="profile-actions">
              <button 
                className="dashboard-button" 
                onClick={() => setShowChangePassword(true)}
              >
                पासवर्ड बदलें | Change Password
              </button>
            </div>
          </div>
        </div>

        {showChangePassword && (
          <div className="modal-backdrop">
            <div className="modal-content">
              <ChangePassword 
                onCancel={() => setShowChangePassword(false)} 
              />
            </div>
          </div>
        )}

        <div className="dashboard-card boats-card">
          <h3>मेरी नावें | My Boats</h3>
          {loading ? (
            <p className="boats-loading">Loading assigned boats...</p>
          ) : assignedBoats.length === 0 ? (
            <p className="no-boats">
              आपको कोई नाव असाइन नहीं की गई है | You don't have any boats assigned yet
            </p>
          ) : (
            <div className="boats-grid">
              {assignedBoats.map(boat => (
                <div 
                  key={boat.boatId} 
                  className="boat-card"
                  style={{ borderColor: boat.color || '#1976d2' }}
                >
                  <div 
                    className="boat-card-header" 
                    style={{ backgroundColor: boat.color || '#1976d2' }}
                  >
                    <h4>{boat.displayName}</h4>
                    <span className="boat-id">ID: {boat.boatId}</span>
                  </div>
                  <div className="boat-details">
                    <div className="boat-detail">
                      <span className="boat-detail-label">प्रकार | Type:</span>
                      <span className="boat-detail-value">{boat.type || 'N/A'}</span>
                    </div>
                    <div className="boat-detail">
                      <span className="boat-detail-label">क्षमता | Capacity:</span>
                      <span className="boat-detail-value">{boat.capacity || 'N/A'}</span>
                    </div>
                    <div className="boat-detail">
                      <span className="boat-detail-label">स्थिति | Status:</span>
                      <span className={`status-badge ${boat.active ? 'active' : 'inactive'}`}>
                        {boat.active ? 'सक्रिय | Active' : 'निष्क्रिय | Inactive'}
                      </span>
                    </div>
                    {boat.description && (
                      <div className="boat-description">
                        <p>{boat.description}</p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;